module.exports = __webpack_public_path__ + "static/media/FotosCentro9.6714163f.jpg";